import { useMutation } from '@tanstack/react-query'

import { putPaymentRequestsBankAccount } from '@src/api'
import { DefaultApiPutPaymentRequestsBankAccountRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const usePutPaymentRequestsBankAccount = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiPutPaymentRequestsBankAccountRequest) =>
      putPaymentRequestsBankAccount(axiosInstance, params),
  })
}
